import React, { PropsWithChildren } from 'react';

export const PageHeader = ({ children }: PropsWithChildren) => {
  return (
    <div className={'bg-white p-5 rounded-xl shadow flex flex-col mt-5'}>
      {children}
    </div>
  );
};
